import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const NoSearchResultsIcon = (props: IconProps) => (
  <Icon
    width="231px"
    height="240px"
    viewBox="0 0 231 240"
    fill="none"
    {...props}
  >
    <circle cx="115.41" cy="116.786" r="111.786" fill="#EBEBEB" opacity=".5" />
    <path
      stroke="#99CAFF"
      strokeDasharray="8 8"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M37.9115 68.8789c-.9508-2.8381-2.8056-5.297-5.2732-6.991l.5659-.8244c-.3824-.2625-.7785-.5079-1.1873-.7348V60h6.7857v1h7.3893v-1h7.9928v1h7.9929v-1h7.9928v1h7.9929v-1h7.9928v1h7.9929v-1h7.993v1h7.993v-1h7.993v1h7.992v-1h7.993v1h7.993v-1h7.993v1h7.993v-1h7.993v1h7.993v-1h7.992v1h7.993v-1h7.993v1h3.997c.951 0 1.855.1891 2.679.5308l.383-.9238c1.955.811 3.52 2.3752 4.331 4.3307l-.924.3831c.341.8239.531 1.7282.531 2.6792v3.8036h1v7.6071h-1v7.6072h1v7.6071h-1v3.8036c0 .951-.19 1.8554-.531 2.6794l.924.383c-.811 1.955-2.376 3.52-4.331 4.331l-.383-.924c-.824.341-1.728.531-2.679.531h-3.886v1h-7.772v-1h-7.771v1h-7.771v-1h-7.772v1h-7.771v-1h-7.772v1h-7.771v-1h-7.772v1h-7.771v-1h-7.771v1h-7.772v-1h-7.771v1h-7.7717v-1h-7.7714v1h-7.7715v-1H73.824v1h-7.7714v-1h-7.7714v1h-7.7715v-1H46.624c-.951 0-1.8553-.19-2.6792-.531l-.3831.924c-1.9555-.811-3.5197-2.376-4.3306-4.331l.9237-.383c-.3417-.824-.5308-1.7284-.5308-2.6794v-3.1464h-1v-6.2929h1v-6.2928h-1v-6.2928h1v-3.1464c0-1.6294-.2667-3.211-.7643-4.6961l-.9482.3177Z"
    />
    <line
      x1="51.0525"
      x2="197.624"
      y1="71.6648"
      y2="71.6648"
      stroke="#99CAFF"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <line
      x1="51.0525"
      x2="197.624"
      y1="83.2858"
      y2="83.2858"
      stroke="#99CAFF"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <line
      x1="51.0525"
      x2="144.767"
      y1="94.7142"
      y2="94.7142"
      stroke="#99CAFF"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      stroke="#FFD599"
      strokeDasharray="8 8"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M188.622 138.165c.951-2.838 2.806-5.297 5.273-6.991l-.566-.825c.383-.262.779-.508 1.188-.735v-.328h-6.786v1H180.342v-1h-7.993v1h-7.993v-1h-7.993v1h-7.993v-1h-7.992v1h-7.993v-1h-7.993v1h-7.993v-1h-7.993v1h-7.993v-1h-7.9926v1h-7.9929v-1h-7.9928v1h-7.9929v-1H60.449v1h-7.9929v-1h-7.9928v1h-7.9929v-1h-7.9929v1h-3.9964c-.951 0-1.8553.189-2.6792.531l-.3831-.924c-1.9555.811-3.5197 2.375-4.3306 4.33l.9237.384c-.3417.823-.5308 1.728-.5308 2.679v3.803h-1v7.607h1v7.608h-1v7.607h1v3.803c0 .951.1891 1.856.5308 2.68l-.9237.383c.8109 1.955 2.3751 3.519 4.3306 4.33l.3831-.923c.8239.341 1.7282.53 2.6792.53h3.8857v1h7.7715v-1h7.7714v1h7.7714v-1h7.7714v1h7.7715v-1h7.7714v1h7.7714v-1h7.7715v1h7.7714v-1h7.7713v1h7.772v-1h7.771v1h7.771v-1h7.772v1h7.771v-1h7.772v1h7.771v-1h7.772v1h7.771v-1h3.886c.951 0 1.855-.189 2.679-.53l.383.923c1.956-.811 3.52-2.375 4.331-4.33l-.924-.383c.342-.824.531-1.729.531-2.68v-3.146h1v-6.293h-1v-6.293h1v-6.293h-1v-3.146c0-1.629.266-3.211.764-4.696l.948.318Z"
    />
    <line
      x1="1"
      x2="147.571"
      y1="-1"
      y2="-1"
      stroke="#FFD599"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeWidth="2"
      transform="matrix(-1 0 0 1 176.481 141.951)"
    />
    <line
      x1="1"
      x2="147.571"
      y1="-1"
      y2="-1"
      stroke="#FFD599"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeWidth="2"
      transform="matrix(-1 0 0 1 176.481 153.572)"
    />
    <line
      x1="1"
      x2="94.7143"
      y1="-1"
      y2="-1"
      stroke="#FFD599"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeWidth="2"
      transform="matrix(-1 0 0 1 176.481 165)"
    />
    <path
      fill="#7E7D8F"
      d="m138.862 151.06 25.128 25.128 9.026-9.027-25.127-25.127-9.027 9.026Z"
    />
    <path
      fill="#282644"
      d="m154.742 174.014 46.44 46.441c4.451 4.451 11.663 4.451 16.104 0 4.451-4.451 4.451-11.663 0-16.104l-46.44-46.44-16.104 16.103Z"
    />
    <path
      fill="#CCE4FF"
      d="M142.774 146.292c17.069-17.069 17.069-44.744 0-61.8136-17.07-17.0695-44.7448-17.0695-61.8143 0-17.0694 17.0696-17.0694 44.7446 0 61.8136 17.0695 17.07 44.7443 17.07 61.8143 0Z"
      opacity=".7"
    />
    <path
      fill="#282644"
      d="M73.5751 76.7438c-21.4247 21.4246-21.4247 56.1712 0 77.5962 21.4246 21.424 56.1709 21.424 77.5959 0 21.425-21.425 21.425-56.1716 0-77.5962-21.435-21.4348-56.1713-21.4348-77.5959 0Zm8.8814 8.8814c16.5186-16.5186 43.3145-16.5186 59.8335 0 16.518 16.5288 16.518 43.3148 0 59.8328-16.519 16.519-43.3149 16.519-59.8335 0-16.5186-16.518-16.5186-43.314 0-59.8328Z"
    />
    <path
      fill="#fff"
      d="M84.2672 110.307c.3844-.263.6677-.668.7587-1.153 1.3858-7.142 5.4725-13.3122 11.5013-17.3786 6.0288-4.0664 13.2818-5.5433 20.4228-4.1575.982.1922 1.932-.4451 2.125-1.4263.192-.9812-.445-1.932-1.427-2.1242-8.092-1.5679-16.306.1011-23.1439 4.7037-6.8279 4.6127-11.4608 11.6029-13.0287 19.6949-.1922.981.445 1.932 1.4262 2.124.4856.091.9711-.02 1.3555-.273l.0101-.01Z"
    />
  </Icon>
);

export default memo(NoSearchResultsIcon);
